import Button from "../Button";
import Modal from "@components/_Revamp/Modal";
import React, { useEffect } from "react";
import { styled } from "@linaria/react";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { css } from "@linaria/core";
import useReduxReset from "@pages/ShieldStarter/Helpers/useReduxReset";
import { SCREEN_SIZE } from "@static/screen-size";

const ModalCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ModalHeader = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #434343;
  flex: none;
  order: 0;
  flex-grow: 1;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
  }
`;

const ModalDescription = styled.div`
  margin-top: 16px;
  max-width: 336px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  margin-bottom: 64px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-weight: 600;
  }
`;

const ButtonContainers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 24px;
`;
const buttonCss = css`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  width: 180px;
  @media screen and (max-width: 470px) {
    width: 100%;
  }
`;

const SessionTimoutClass = css`
  z-index: 1000;
`;

export default function ShieldStarterSessionTimeout({
  showSessionModal,
  setShowSessionModal,
  onGetNewQuote,
}: any) {
  const history = useHistory();
  const resetRedux = useReduxReset();
  useEffect(() => {
    resetRedux();
  }, []);

  return (
    <Modal className={SessionTimoutClass} show={true}>
      <ModalCard>
        <ModalHeader>Your session has expired</ModalHeader>
        <ModalDescription>
          Let&apos;s get a new quote for you. Please note that any changes you
          made earlier won&apos;t be saved.
        </ModalDescription>
        <ButtonContainers>
          <Button
            className={buttonCss}
            // bgColor="white"
            // textColor="#883E89"
            // hoverBgColor="white"
            // hoverTextColor="#883E89"
            label={"Get a new quote"}
            onClick={() => {
              setShowSessionModal(false);
              onGetNewQuote();
            }}
          />
          {/* <Button
            className={buttonCss}
            label={"Contact us"}
            onClick={() => {
              resetRedux();
              setShowSessionModal(false);
              history.push(ROUTE_PATH.SHIELD_STARTER_CONTACT_US);
            }}
          /> */}
        </ButtonContainers>
      </ModalCard>
    </Modal>
  );
}
